<template>
  <div class="single-ticket-cargo-order-list">
    <el-card class="box-card">
      <!-- 搜索工具栏 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="投保人">
            <el-input v-model="searchForm.policyholder" placeholder="投保人" clearable></el-input>
          </el-form-item>
          <el-form-item label="被保险人">
            <el-input v-model="searchForm.beneficiary" placeholder="被保险人" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="searchForm.mobile" placeholder="手机号码" clearable></el-input>
          </el-form-item>
          <el-form-item label="保单号">
            <el-input v-model="searchForm.policy_no" placeholder="保单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="车牌号">
            <el-input v-model="searchForm.plate_no" placeholder="车牌号" clearable></el-input>
          </el-form-item>

          <el-form-item label="投保时间">
            <el-date-picker
              v-model="searchForm.insuranceDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="投保状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
              <el-option label="未支付" value="1"></el-option>
              <el-option label="已取消" value="2"></el-option>
              <el-option label="已支付" value="4"></el-option>
              <el-option label="已过期" value="8"></el-option>
              <el-option label="理赔中" value="16"></el-option>
              <el-option label="理赔完成" value="32"></el-option>
              <el-option label="已退款" value="64"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="支付方式">
            <el-select v-model="searchForm.pay_type" placeholder="请选择支付方式" clearable>
              <el-option label="余额支付" value="1"></el-option>
              <el-option label="睿保对接的微信支付" value="2"></el-option>
              <el-option label="鼎盛支付" value="4"></el-option>
              <el-option label="保险公司支付链接" value="8"></el-option>
              <el-option label="线下支付" value="16"></el-option>
              <el-option label="鼎盛余额支付" value="32"></el-option>
              <el-option label="中际支付" value="64"></el-option>
              <el-option label="线上余额支付" value="256"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="投保类型">
            <el-select v-model="searchForm.insure_type" placeholder="请选择投保类型" clearable>
              <el-option label="客户投保" value="1"></el-option>
              <el-option label="代客投保" value="2"></el-option>
              <el-option label="线下投保" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="产品名称">
            <el-select v-model="searchForm.product_id" filterable placeholder="产品名称" clearable>
              <el-option v-for="p in productOptions" :key="p.id" :label="p.name" :value="p.id" />
            </el-select>
          </el-form-item>

          <el-form-item label="生效时间">
            <el-date-picker
              v-model="searchForm.effectiveDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="生效时间"
              end-placeholder="失效时间"
              value-format="timestamp">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="保险公司">
            <el-select v-model="searchForm.insurance_type" filterable placeholder="保险公司" clearable>
              <el-option v-for="c in companyOptions" :key="c.id" :label="c.name" :value="c.id" />
            </el-select>
          </el-form-item>

          <el-form-item label="价格方案">
            <el-select v-model="searchForm.price_id" filterable placeholder="价格方案" clearable>
              <el-option v-for="pr in priceOptions" :key="pr.price_id" :label="pr.price_name" :value="pr.price_id" />
            </el-select>
          </el-form-item>

          <el-form-item label="渠道商">
            <!-- 渠道商输入框 -->
            <el-autocomplete
              v-model="searchForm.channel"
              :fetch-suggestions="queryChannel"
              placeholder="渠道商"
              clearable
              style="width: 220px;"
              @select="handleChannelSelect"
            >
              <template slot-scope="{ item }">
                <div>{{ item.name || item.realname }}<span v-if="item.alias"> ({{ item.alias }})</span></div>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="success" @click="handleExportExcel">导出Excel</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 保费总额显示 -->
      <div class="premium-total">
        保费总额：<span class="total-amount">¥{{ formatMoney(premiumTotal) }}</span>
      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%" border v-loading="loading">
        <el-table-column prop="policyholder" label="投保人" width="270" align="center">
          <template slot-scope="scope">
            <span class="link" @click="viewPolicyholderDetail(scope.row.policyholder)">{{ scope.row.policyholder }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="beneficiary" label="被保险人" width="270" align="center">
          <template slot-scope="scope">
            <span class="link" @click="viewPolicyholderDetail(scope.row.beneficiary)">{{ scope.row.beneficiary }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="200" align="center" />
        <el-table-column prop="insurance_company_name" label="保险公司" width="180" align="center" />
        <el-table-column prop="product_name" label="产品名称" width="280" align="center" />
        <el-table-column prop="price_name" label="价格方案" width="180" align="center" />
        <el-table-column prop="channel_name" label="渠道" width="160" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.channel_name">{{ scope.row.channel_name }} ({{ scope.row.alias }})</span>
            <span v-else>{{ scope.row.alias }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="policy_no" label="保单号" width="180" align="center">
          <template slot-scope="scope">
            <span class="link" @click="viewOrderDetail(scope.row.id)">{{ scope.row.policy_no || '保单详情' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="source" label="来源" width="210" align="center" :formatter="sourceFormat" />
        <el-table-column prop="coverage" label="保额" width="105" align="center" :formatter="coverageFormat" />
        <el-table-column prop="plate_no" label="车牌号" width="280" align="center" :formatter="plateNoFormat" />
        <el-table-column prop="track_no" label="运单号" width="160" align="center" />
        <el-table-column prop="cargo_name" label="货物名称" width="160" align="center" />
        <el-table-column prop="quantity" label="货物数量" width="160" align="center" />
        <el-table-column prop="packing" label="包装方式" width="160" align="center" />
        <el-table-column prop="bind_haulway" label="运输路线" width="280" align="center" :formatter="haulwayFormat" />
        <el-table-column prop="distance" label="距离" width="80" align="center" :formatter="distanceFormat" />
        <el-table-column prop="carriage" label="运费" width="70" align="center" :formatter="moneyFormat" />
        <el-table-column prop="price" label="价格" width="70" align="center" :formatter="moneyFormat" />
        <el-table-column prop="discount" label="折扣" width="70" align="center" :formatter="moneyFormat" />
        <el-table-column prop="pay_price" label="实付" width="70" align="center" :formatter="moneyFormat" />
        <el-table-column prop="pay_type" label="支付方式" width="140" align="center" :formatter="payTypeFormat" />
        <el-table-column prop="insure_type" label="投保类型" width="140" align="center" :formatter="insureTypeFormat" />
        <el-table-column prop="created_at" label="投保时间" width="240" align="center" :formatter="dateFormat" />
        <el-table-column prop="status" label="保单状态" width="70" align="center" :formatter="statusFormat" />
        <el-table-column prop="note" label="备注" width="300" align="center" />
        <el-table-column prop="effected_at" label="起保时间" width="240" align="center" :formatter="dateFormat" />
        <el-table-column prop="expired_at" label="终保时间" width="240" align="center" :formatter="dateFormat" />
        <el-table-column prop="seq_no" label="序号" width="280" align="center" />
        <el-table-column label="操作" width="320" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 4 && !scope.row.policy_url" type="text" @click="handleReIssue(scope.row.id)">重新出单</el-button>
            <el-button v-if="scope.row.policy_url && scope.row.policy_no && scope.row.insurance_type === 243" type="text" @click="handleReGetPolicy(scope.row.id)">重新获取电子保单</el-button>
            <el-button v-if="scope.row.status === 4 && !scope.row.policy_no && scope.row.insurance_type === 243" type="text" @click="handleEnteringPolicy(scope.row.id)">保单号录入</el-button>
            <el-button v-if="scope.row.pay_type === 32 && scope.row.status === 4" type="text" @click="handlePolicyCallback(scope.row.id)">保单信息回传</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px;"
      />
    </el-card>

    <!-- 保单号录入弹窗（占位） -->
    <el-dialog title="保单号录入" :visible.sync="enteringDialogVisible" width="480px">
      <el-input v-model="enteringPolicyNo" placeholder="请输入保单号" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="enteringDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEnteringPolicy">确定</el-button>
      </span>
    </el-dialog>

    <!-- 保单详情弹窗 -->
    <el-dialog title="保单详情" :visible.sync="detailDialogVisible" width="640px">
      <el-descriptions v-loading="orderDetailLoading" :column="2" border>
        <el-descriptions-item label="保单号">{{ orderDetail.policy_no || '-' }}</el-descriptions-item>
        <el-descriptions-item label="投保人">{{ orderDetail.policyholder || '-' }}</el-descriptions-item>
        <el-descriptions-item label="被保险人">{{ orderDetail.beneficiary || '-' }}</el-descriptions-item>
        <el-descriptions-item label="保险公司">{{ orderDetail.insurance_company_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="产品">{{ orderDetail.product_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="价格方案">{{ orderDetail.price_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="保额">{{ coverageFormat(orderDetail.coverage) }}</el-descriptions-item>
        <el-descriptions-item label="车牌号">{{ plateNoFormat(orderDetail) }}</el-descriptions-item>
        <el-descriptions-item label="起保时间">{{ dateFormat(orderDetail.effected_at) }}</el-descriptions-item>
        <el-descriptions-item label="终保时间">{{ dateFormat(orderDetail.expired_at) }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ statusFormat(orderDetail.status) }}</el-descriptions-item>
        <el-descriptions-item label="实付">{{ moneyFormat(orderDetail.pay_price) }}</el-descriptions-item>
        <el-descriptions-item label="电子保单">
          <a v-if="orderDetail.policy_url" :href="orderDetail.policy_url" target="_blank">查看</a>
          <span v-else>-</span>
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ExportJsonExcel from 'js-export-excel'
import { getCustomOrderList, getCustomOrderInfo, reIssueOrder, reGetPolicy, policyCallback } from '@/api/custom-order'
import { getChannelList } from '@/api/member'
import { getProductList as getCmnProductList } from '@/api/claim'
import { getProductConfigList } from '@/api/product'
import { getInsuranceCompanyList } from '@/api/claim'

export default {
  name: 'SingleTicketCargoOrderList',
  data() {
    return {
      loading: false,
      searchForm: {
        policyholder: '',
        beneficiary: '',
        mobile: '',
        policy_no: '',
        plate_no: '',
        insuranceDateRange: [],
        status: '',
        pay_type: '',
        insure_type: '',
        product_id: '',
        effectiveDateRange: [],
        insurance_type: '',
        price_id: '',
        channel: ''
      },
      tableData: [],
      premiumTotal: 0,
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      channelList: [],
      selectedChannel: null,
      productOptions: [],
      priceOptions: [],
      companyOptions: [],
      enteringDialogVisible: false,
      enteringPolicyOrderId: null,
      enteringPolicyNo: '',
      // 订单详情弹窗
      detailDialogVisible: false,
      orderDetailLoading: false,
      orderDetail: {}
    }
  },
  created() {
    this.fetchData()
    this.fetchChannelList()
    this.fetchProductOptions()
    this.fetchPriceOptions()
    this.fetchCompanyOptions()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize,
          ...this.buildSearchParams()
        }
        const res = await getCustomOrderList(params)
        this.tableData = res.rows || []
        this.pagination.total = res.total || (res.rows ? res.rows.length : 0)
        this.premiumTotal = res.sum || 0
      } catch (e) {
        this.$message.error('获取订单列表失败')
      } finally {
        this.loading = false
      }
    },
    buildSearchParams() {
      const p = {}
      if (this.searchForm.policyholder) p.policyholder = this.searchForm.policyholder
      if (this.searchForm.beneficiary) p.beneficiary = this.searchForm.beneficiary
      if (this.searchForm.mobile) p.mobile = this.searchForm.mobile
      if (this.searchForm.policy_no) p.policy_no = this.searchForm.policy_no
      if (this.searchForm.plate_no) p.plate_no = this.searchForm.plate_no
      if (this.searchForm.insuranceDateRange && this.searchForm.insuranceDateRange.length === 2) {
        p.begin_date = Math.floor(this.searchForm.insuranceDateRange[0] / 1000)
        p.end_date = Math.floor(this.searchForm.insuranceDateRange[1] / 1000)
      }
      if (this.searchForm.status) p.status = this.searchForm.status
      if (this.searchForm.pay_type) p.pay_type = this.searchForm.pay_type
      if (this.searchForm.insure_type) p.insure_type = this.searchForm.insure_type
      if (this.searchForm.product_id) p.product_id = this.searchForm.product_id
      if (this.searchForm.effectiveDateRange && this.searchForm.effectiveDateRange.length === 2) {
        p.effected_at = Math.floor(this.searchForm.effectiveDateRange[0] / 1000)
        p.expired_at = Math.floor(this.searchForm.effectiveDateRange[1] / 1000)
      }
      if (this.searchForm.insurance_type) p.insurance_type = this.searchForm.insurance_type
      if (this.searchForm.price_id) p.price_id = this.searchForm.price_id
      if (this.searchForm.channel && this.selectedChannel) {
        p.channel_id = this.selectedChannel.id
      }
      return p
    },
    async fetchChannelList() {
      try {
        const res = await getChannelList()
        this.channelList = res.rows || []
      } catch (e) {
        // ignore
      }
    },
    async fetchProductOptions() {
      try {
        const res = await getCmnProductList()
        this.productOptions = res.rows || []
      } catch (e) {}
    },
    async fetchPriceOptions() {
      try {
        const res = await getProductConfigList()
        this.priceOptions = (res.rows || []).filter(i => i.price_name)
      } catch (e) {}
    },
    async fetchCompanyOptions() {
      try {
        const res = await getInsuranceCompanyList()
        this.companyOptions = res.rows || []
      } catch (e) {}
    },
    queryChannel(queryString, cb) {
      const results = queryString
        ? this.channelList.filter(item => {
            const name = (item.name || item.realname || '').toLowerCase()
            const alias = (item.alias || '').toLowerCase()
            const q = queryString.toLowerCase()
            return name.includes(q) || alias.includes(q)
          })
        : this.channelList
      cb(results)
    },
    handleChannelSelect(item) {
      this.selectedChannel = item
    },
    resetSearchForm() {
      this.searchForm = {
        policyholder: '',
        beneficiary: '',
        mobile: '',
        policy_no: '',
        plate_no: '',
        insuranceDateRange: [],
        status: '',
        pay_type: '',
        insure_type: '',
        product_id: '',
        effectiveDateRange: [],
        insurance_type: '',
        price_id: '',
        channel: ''
      }
      this.selectedChannel = null
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchData()
    },
    handleReset() {
      this.resetSearchForm()
      this.pagination.currentPage = 1
      this.fetchData()
    },
    async handleExportExcel() {
      try {
        const params = {
          ...this.buildSearchParams()
        }
        const res = await getCustomOrderList(params)
        const rows = res.rows || []
        if (!rows.length) {
          this.$message.warning('没有数据可导出')
          return
        }
        const datas = [{
          sheetData: rows.map(r => ({
            '投保人': r.policyholder,
            '被保险人': r.beneficiary,
            '手机号': r.mobile,
            '保险公司': r.insurance_company_name,
            '产品名称': r.product_name,
            '价格方案': r.price_name,
            '渠道': r.channel_name ? `${r.channel_name}(${r.alias})` : r.alias,
            '保单号': r.policy_no,
            '来源': this.sourceFormat(r.source),
            '保额': this.coverageFormat(r.coverage),
            '车牌号': this.plateNoFormat(r),
            '运单号': r.track_no,
            '货物名称': r.cargo_name,
            '货物数量': r.quantity,
            '包装方式': r.packing,
            '运输路径': this.haulwayFormat(null, r),
            '距离': this.distanceFormat(r.distance),
            '运费（元）': this.moneyFormat(r.carriage),
            '原价（元）': this.moneyFormat(r.price),
            '折扣（元）': this.moneyFormat(r.discount),
            '实付（元）': this.moneyFormat(r.pay_price),
            '支付方式': this.payTypeFormat(r.pay_type),
            '投保时间': this.dateFormat(r.created_at),
            '保单状态': this.statusFormat(r.status),
            '备注': r.note,
            '生效时间': this.dateFormat(r.effected_at),
            '结束时间': this.dateFormat(r.expired_at)
          })),
          sheetName: 'sheet',
          sheetHeader: ['投保人','被保险人','手机号','保险公司','产品名称','价格方案','渠道','保单号','来源','保额','车牌号','运单号','货物名称','货物数量','包装方式','运输路径','距离','运费（元）','原价（元）','折扣（元）','实付（元）','支付方式','投保时间','保单状态','备注','生效时间','结束时间']
        }]
        const ex = new ExportJsonExcel({ fileName: '自定义订单', datas })
        ex.saveExcel()
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
      }
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.fetchData()
    },
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.fetchData()
    },
    viewPolicyholderDetail(name) {
      this.$message.info(`查看用户详情：${name}`)
    },
    async viewOrderDetail(id) {
      this.orderDetailLoading = true
      try {
        const res = await getCustomOrderInfo({ id })
        const info = res.order || res.info || null
        if (info) {
          this.orderDetail = info
          this.detailDialogVisible = true
        } else {
          this.$message.error('获取订单详情失败')
        }
      } catch (e) {
        this.$message.error('获取订单详情失败')
      } finally {
        this.orderDetailLoading = false
      }
    },
    async handleReIssue(id) {
      try {
        const res = await reIssueOrder({ id })
        if (res.err_code === 0) {
          this.$message.success('重新出单成功')
          this.fetchData()
        } else {
          this.$message.error(res.err_msg || '操作失败')
        }
      } catch (e) {
        this.$message.error('重新出单失败')
      }
    },
    async handleReGetPolicy(id) {
      try {
        const res = await reGetPolicy({ id })
        if (res.err_code === 0) {
          this.$message.success('获取电子保单成功')
          this.fetchData()
        } else {
          this.$message.error(res.err_msg || '操作失败')
        }
      } catch (e) {
        this.$message.error('获取电子保单失败')
      }
    },
    handleEnteringPolicy(id) {
      this.enteringPolicyOrderId = id
      this.enteringPolicyNo = ''
      this.enteringDialogVisible = true
    },
    submitEnteringPolicy() {
      if (!this.enteringPolicyNo) {
        this.$message.warning('请输入保单号')
        return
      }
      // 具体录入接口未在老页面显式展示，这里先占位提示
      this.$message.info('保单号录入功能待对接后端接口')
      this.enteringDialogVisible = false
    },
    async handlePolicyCallback(id) {
      this.$confirm('您确定要手动回传吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await policyCallback({ order_id: id, product_alias: 'gxb' })
          if (res.err_code === 0) {
            this.$message.success('修改回传成功')
            this.fetchData()
          } else {
            this.$message.error(res.err_msg || '回传失败')
          }
        } catch (error) {
          this.$message.error('回传失败')
        }
      }).catch(() => {})
    },
    // 格式化与老项目一致
    sourceFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === 'object' ? arg3 : arg1
      switch ((v || 0) * 1) {
        case 0:
          return '未知来源'
        case 1:
          return 'PC浏览器端投保'
        case 2:
          return '移动浏览器端投保'
        case 4:
          return 'iOS端投保'
        case 8:
          return '安卓端投保'
        case 16:
          return 'API投保'
        case 32:
          return '微信小程序'
        case 64:
          return '渠道管理后台'
        case 128:
          return '内部管理后台'
        case 256:
          return '移动浏览器端投保-代理人H5'
        case 512:
          return '移动浏览器端投保-代客投保'
        default:
          return '未知来源'
      }
    },
    coverageFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === 'object' ? arg3 : arg1
      if (v == null) return ''
      return `${(v / 10000)}万`
    },
    plateNoFormat(row) {
      if (!row) return ''
      let s = row.plate_no || ''
      if (row.plate_extra_no) s += `;挂：${row.plate_extra_no}`
      return s
    },
    haulwayFormat(row) {
      if (!row) return ''
      return `${row.start_province || ''}${row.start_city || ''}-${row.end_province || ''}${row.end_city || ''}`
    },
    distanceFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === 'object' ? arg3 : arg1
      console.log(v,12);
      
      if (v == null) return ''
      return `${v}公里`
    },
    moneyFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === 'object' ? arg3 : arg1
      if (v == null) return ''
      return (v / 100).toFixed(2)
    },
    payTypeFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === 'object' ? arg3 : arg1
      const map = {
        0: '未知状态',
        1: '余额支付',
        2: '睿保对接的微信支付',
        4: '鼎盛支付',
        8: '保险公司支付链接',
        16: '线下支付',
        32: '鼎盛余额支付',
        64: '中际支付',
        128: '布谷维客微信支付',
        256: '线上余额支付'
      }
      return map[v] || '未知状态'
    },
    insureTypeFormat(arg1, arg2, arg3) {
      // 兼容 el-table 的 formatter(row, column, cellValue, index)
      const raw = typeof arg1 === 'object' && arg2 && arg2.property
        ? arg1[arg2.property]
        : (typeof arg1 === 'object' ? arg3 : arg1)

      if (raw === undefined || raw === null || raw === '') return ''

      const v = typeof raw === 'number' ? raw : Number(raw)
      const map = { 1: '客户投保', 2: '代客投保', 4: '线下投保' }
      return map[v] || ''
    },
    dateFormat(arg1, arg2, arg3) {
      // 兼容 el-table 的 formatter(row, column, cellValue, index)
      const raw = typeof arg1 === 'object' && arg2 && arg2.property
        ? arg1[arg2.property]
        : (typeof arg1 === 'object' ? arg3 : arg1)

      if (raw === undefined || raw === null || raw === '') return ''

      let ms = raw
      if (typeof raw === 'number') {
        // 数字时间戳：小于 1e12 视为秒，转换为毫秒
        ms = raw < 1e12 ? raw * 1000 : raw
      } else if (typeof raw === 'string') {
        if (/^\d+$/.test(raw)) {
          // 纯数字字符串时间戳
          const num = Number(raw)
          ms = num < 1e12 ? num * 1000 : num
        } else {
          // 规范化常见的非 ISO 字符串：YYYY-MM-DD HH:mm:ss -> YYYY/MM/DD HH:mm:ss
          const normalized = raw.replace(/-/g, '/').replace('T', ' ').replace(/Z$/i, '')
          ms = normalized
        }
      } else {
        return ''
      }

      const d = new Date(ms)
      if (!d || isNaN(d.getTime())) return ''
      if (d.getFullYear() <= 1971) return ''
      const pad = n => (n < 10 ? '0' + n : n)
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    statusFormat(arg1, arg2, arg3) {
      // 兼容 el-table 的 formatter(row, column, cellValue, index)
      const raw = typeof arg1 === 'object' && arg2 && arg2.property
        ? arg1[arg2.property]
        : (typeof arg1 === 'object' ? arg3 : arg1)

      if (raw === undefined || raw === null || raw === '') return ''

      const v = typeof raw === 'number' ? raw : Number(raw)
      const map = { 1: '未支付', 2: '已取消', 4: '已支付', 8: '已过期', 16: '理赔中', 32: '理赔完成', 64: '已退款' }
      return map[v] || ''
    },
    formatMoney(v) {
      return Number(v/100 || 0).toFixed(2)
    }
  }
}
</script>

<style lang="less" scoped>
.single-ticket-cargo-order-list {
  .search-toolbar {
    margin-bottom: 12px;
  }
  .premium-total {
    margin-bottom: 12px;
    .total-amount {
      color: #ff7300;
      font-weight: 600;
    }
  }
  .link {
    color: #409EFF;
    cursor: pointer;
  }
}
</style>
